<template>
  <section id="reset">
    <div class="container">
      <div class="logo-cont">
        <div class="logo">
          <GridxLogo />
        </div>
      </div>
      <CheckCircle class="check-circle" />
      <div class="login-fields col-12 col-md-4 offset-md-4">
        <h1>Te enviamos un mail</h1>
        <p>
          Revisá tu casilla de correo y hace click en el enlace
          que te mandamos para crear una nueva contraseña.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import GridxLogo from '../assets/icons/gridx-logo.svg';
import CheckCircle from '../assets/icons/check-circle.svg';

export default {
  name: 'Login',
  components: {
    GridxLogo,
    CheckCircle,
  },
};
</script>

<style lang="scss" scoped>
.check-circle {
  margin: 0 auto;
  display: block;
  margin-bottom: 50px;
}
#reset {
  height: 100vh;
  background: #619e7a;
  overflow: hidden;
  padding-top: 50px;

  h1 {
    font-weight: bold;
    font-size: 24px;
    text-align: center;
    color: #330e2f;
  }
}

.logo-cont {
  height: 185px;
}

.logo {
  display: block;
  margin: 0 auto;
  position: relative;
  padding-top: 100px;
  height: 29px;
  svg {
    margin: 0 auto;
    display: block;
    height: 29px;
  }
}

.login-bg {
  position: absolute;
  right: 15px;
  max-width: 752px;
}

.login-fields {
  margin-top: 30px;
}

.login-button-container {
  margin-top: 20vh;
}

.login-button {
  width: 100%;
}

.error {
  font-size: 16px;
  color: #ff5f3c;
  position: absolute;
}

.forgot-password {
  float: right;
  margin-top: 10px;
}

p {
  color: #fff;
}
</style>
